'use strict'

/**
 *
 * @name: nnSeasonItem
 *
 */

import DirectiveTemplate from './nn-season-item.directive.html'
import './nn-season-item.directive.scss'

function NnSeasonItemDirective () {

  'ngInject'

  return {
    restrict: 'E',
    replace: true,
    scope: {
      season: '=*'
    },
    template: DirectiveTemplate,
    controller: DirectiveController
  }
}

function DirectiveController () {

  'ngInject'

  /*
   *
   * @CONFIG
   *
   */



  /*
   *
   * @PUBLIC
   *
   */


  /*
   *
   * @PRIVATE
   *
   */



  /*
   *
   * @INIT
   *
   */
}

export default NnSeasonItemDirective



// WEBPACK FOOTER //
// ./app/components/nn-season-item/nn-season-item.directive.js